export class TaxStatement {
    taxYear: string;
    taxForm: string;
    downloadLink: string;
}
